<template>
  <span class="table-row-actions">
    <span v-if="$slots.view" class="table-row-actions__item">
      <slot name="view" />
    </span>
    <span v-if="$slots.edit" class="table-row-actions__item">
      <slot name="edit" />
    </span>
    <span v-if="showDelete" class="table-row-actions__item">
      <slot name="delete" />
    </span>
  </span>
</template>

<script>
export default {
  name: "TableRowActions",
  props: {
    showDelete: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped lang="scss">
.table-row-actions {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
}

.table-row-actions__item {
  min-width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}
</style>
